import { render } from "./Trim.vue?vue&type=template&id=4f709aed"
import script from "./Trim.vue?vue&type=script&lang=js"
export * from "./Trim.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__